import TableComponent, { TableComponentType } from 'UI/Table'
import { IColumn } from 'typescript/interfaces/tableUi'
import { useTableComponentStyle } from 'UI/Table/style'
import { convertDate, convertEmptyField, convertToPriceFormat } from 'utils/formatters'
import { IRejectedListItem } from 'typescript/interfaces/transactions'
import { SortFieldsRejected } from 'typescript/enums/transactions'
import { Button } from '@material-ui/core'
import React, { useContext, useRef } from 'react'
import { UserContext } from 'contexts/userContext'

export const TableRejectedQueues = TableComponent as TableComponentType<IRejectedListItem>

interface IUseRejectedQueueProps {
  resolve: (rejected: IRejectedListItem) => void
}

export const useRejectedQueuesTable = ({ resolve }: IUseRejectedQueueProps) => {
  const { state } = useContext(UserContext)
  const classes = useTableComponentStyle()
  const columns = useRef<Array<IColumn<IRejectedListItem>>>([
    {
      label: 'Date of Rejection',
      field: SortFieldsRejected.dateOfRejection,
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: true,
      render: (data) => convertDate(data.dateOfRejection),
    },
    {
      label: 'Payment #',
      field: SortFieldsRejected.paymentId,
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: true,
      render: (data) => convertEmptyField(data.paymentId),
    },
    {
      label: 'Deal #',
      field: SortFieldsRejected.dealId,
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: true,
      render: (data) => convertEmptyField(data.dealId),
    },
    {
      label: 'Deal Name',
      field: 'dealName',
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: false,
      render: (data) => convertEmptyField(data.dealName),
    },
    {
      label: 'Payment',
      field: SortFieldsRejected.paymentAmount,
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: true,
      render: (data) => convertToPriceFormat(data.paymentAmount),
    },
    {
      label: 'Scheduled For',
      field: SortFieldsRejected.scheduledFor,
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: true,
      render: (data) => convertDate(data.scheduledFor),
    },
    {
      label: 'Company',
      field: SortFieldsRejected.company,
      bodyCellClassName: classes.accentCell,
      sorting: true,
      render: (data) => convertEmptyField(data.company),
    },
    {
      label: 'Reason of Rejection',
      field: 'reasonOfRejection',
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: false,
      render: (data) => convertEmptyField(data.reasonOfRejection),
    },
    {
      label: 'Amount to get Current',
      field: 'AmountToGetCurrent',
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: false,
      render: (data) => convertToPriceFormat(data.amountToGetCurrent),
    },
    ...(state.roles.isAdmin
      ? [
          {
            label: '',
            field: 'actions',
            render: (data) => (
              <Button disabled={data.isResolved} color="secondary" variant="outlined" size="small" onClick={() => resolve(data)}>
                Resolve
              </Button>
            ),
          } as IColumn<IRejectedListItem>,
        ]
      : []),
  ])

  return {
    columns: columns.current,
  }
}
